<template>
  <div>

    <b-row>
      <b-col xxs="12" lg="6">

        <form-base title="Update account details" action="Update" :errors="errors" :loading="loading"  v-on:handleSubmit="handleSubmit">

           <template v-slot:fields>

            

               <label class="form-group has-float-label mb-4">
                <input
                  type="text"
                  @blur="$v.user.name.$touch"
                  class="form-control"
                  :class="{ 'is-invalid': $v.user.name.$error }"
                  v-model="user.name"
                />
                <span>Full Name</span>
                <div class="invalid-feedback" v-if="!$v.user.name.required">
                  Please enter full name
                </div>
              </label>

              <label class="form-group has-float-label mb-4">
                <input
                  type="email"
                  class="form-control"
                  :class="{ 'is-invalid': $v.user.email.$error }"
                  v-model="user.email"
                />
                <span>Email</span>
                <div class="invalid-feedback" v-if="!$v.user.email.required">
                  Please enter email address
                </div>
                <div class="invalid-feedback" v-if="!$v.user.email.email">
                  invalid email address
                </div>
              </label>

              <label class="form-group has-float-label mb-4">
                <input
                  type="password"
                  class="form-control"
                  :class="{ 'is-invalid': $v.user.new_password.$error }"
                  v-model="user.new_password"
                />
                <span>New Password</span>
                <small>Only enter a password if you want to change it</small>
                <div class="invalid-feedback" v-if="!$v.user.new_password.minLength">
                  Please enter password with a minimun of 6 characters
                </div>
              </label>

                 <label class="form-group has-float-label mb-4">
                <input
                  type="password"
                  class="form-control"
                  v-model="user.old_password"
                />
                <span>Old Password</span>
                <small>Only enter a password if you want to change it</small>

              </label>

              <label>Profile Picture</label>
              <image-upload
              @files-uploaded="user.image_id = $event; imageUploading = false"
              @files-uploaded-started="imageUploading = true"
              :multiple=false
              :imageCrop=true
              :imageCropRatio=1/1
              :validationState="imageVstate"
              acceptedTypes="image/*"></image-upload>
            </template>
        </form-base>
      </b-col>
      <b-col lg="6" class="d-none d-lg-block">
        <div class="text-right">
         
            <img 
              v-if="user.image"
              :src="user.image"  class="mb-5 img-fluid img-thumbnail" />
        
        </div>
         
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required, email, minLength } from 'vuelidate/lib/validators'
import formBase from '@/components/common/FormBase'
import imageUpload from '@/components/common/ImageUpload'
import { mapActions } from 'vuex'

export default {
  components: {
    formBase,
    imageUpload
  },

  computed: {
    imageVstate () {
      return null
    }

  },

  mounted () {
    this.getUser()
  },

  validations: {
    user: {
      name: {
        required
      },
      email: {
        required,
        email
      },
      new_password: {
        minLength: minLength(6)
      }
    }
  },

  data () {
    return {
      user: {},
      loading: false,
      errors: null,
      imageUploading: false
    }
  },

  methods: {
    ...mapActions('user', ['doUpdateAccount']),
    async getUser () {
      try {
        this.user = this.$store.state.user.user
      } catch (error) {
        console.log(error)
      }
    },

    async handleSubmit () {
      this.loading = true
      this.$v.$touch()
      if (this.$v.$invalid || this.imageUploading) {
        if (this.imageUploading) alert('images uploading...')
        this.loading = false
      } else {
        try {
          await this.doUpdateAccount(this.user)
          this.$root.$bvToast.toast('Profile Updated', {
            title: 'Success',
            autoHideDelay: 3000,
            variant: 'success',
          })
          this.$router.push({ name: 'home' })
        } catch (error) {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors
            this.$root.$bvToast.toast('Error', {
              title: 'Form errors',
              autoHideDelay: 3000,
              variant: 'danger',
            })
            console.log(this.errors)
          }else{
            this.$root.$bvToast.toast('Error', {
              title: 'Something went wrong',
              autoHideDelay: 3000,
              variant: 'danger',
            })
          }
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>

<style></style>
